import { Button, DatePicker, Empty, Form, InfiniteScroll, List, NavBar, Popup, Space, Tag, Toast } from 'antd-mobile';
import { CloseCircleOutline, FilterOutline, RightOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listMyApproveHis } from '../componet/service';
import '../styles/BorrowHisPage.css';

const ApproveHisPage = () => {
    const navigate = useNavigate();
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterVisible, setFilterVisible] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const pageSize = 20;
    const [clear, setClear] = useState(true);
    const [filter, setFilter] = useState({
        approveType: '',
        applyStartTime: null,
        applyEndTime: null
    });
    const [filterConfig, setFilterConfig] = useState(filter);
    const allApproveTypes = ['申请转移', '申请归还'];
    const [form] = Form.useForm();

    // 获取借出记录
    const fetchBorrowRecords = async (pageNum = 1, isLoadMore = false) => {
        if (pageNum === 1) {
            setLoading(true);
        }
        try {
            const res = await listMyApproveHis(pageNum, pageSize, filter)
            const hisList = res.data.content;
            // 更新数据和分页状态
            let totalRecords = [...records, ...hisList];
            setRecords(totalRecords);
            // 判断是否还有更多数据
            setHasMore(res.data.totalCnt > totalRecords.length);
            setPage(pageNum);
            setLoading(false);
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: '获取数据失败'
            });
            setLoading(false);
            setHasMore(false);
        }
    };

    useEffect(() => {
        setRecords([]);
        setPage(1);
        setHasMore(true);
        setClear(true);
    }, [filter]);

    useEffect(() => {
        if (clear) {
            fetchBorrowRecords(1, false);
            setClear(false);
        }
    }, [clear]);

    // 加载更多数据
    const loadMore = async () => {
        if (!hasMore) return;
        const nextPage = page + 1;
        await fetchBorrowRecords(nextPage, true);
    };
    // 应用筛选条件
    const applyFilter = (values) => {
        setFilter({ ...filterConfig });
        setFilterVisible(false);
    };

    // 重置筛选条件
    const resetFilter = () => {
        const emptyFilter = {
            approveType: '',
            applyStartTime: null,
            applyEndTime: null
        };
        setFilter(emptyFilter);
        setFilterConfig(emptyFilter);
        form.resetFields();
        setFilterVisible(false);
    };

    // 查看详情
    const viewDetail = (record) => {
        navigate(`/approve-detail/${record.id}`, { state: { record } });
    };

    // 渲染状态标签
    const renderStatusTag = (status) => {
        if (status === '已归还') {
            return <Tag color='success' fill='outline'>{status}</Tag>;
        }
        return <Tag color='primary' fill='outline'>{status}</Tag>;
    };

    return (
        <div className="borrow-history-container">
            <NavBar
                back="返回"
                onBack={() => navigate(-1)}
                right={
                    <FilterOutline
                        fontSize={24}
                        onClick={() => setFilterVisible(true)}
                    />
                }
            >
                我的审批记录
            </NavBar>

            {/* 筛选条件摘要 */}
            {(filter.approveType || filter.applyStartTime || filter.applyEndTime) && (
                <div className="filter-summary">
                    <Space wrap>
                        {filter.approveType && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, approveType: '' })}
                            >
                                状态: {filter.approveType}
                            </Tag>
                        )}
                        {(filter.applyStartTime || filter.applyEndTime) && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, applyStartTime: null, applyEndTime: null })}
                            >
                                时间: {filter.applyStartTime ? new Date(filter.applyStartTime).toLocaleDateString() : '不限'}
                                至
                                {filter.applyEndTime ? new Date(filter.applyEndTime).toLocaleDateString() : '不限'}
                            </Tag>
                        )}
                        <Button
                            size='mini'
                            onClick={resetFilter}
                        >
                            清除全部
                        </Button>
                    </Space>
                </div>
            )}

            {/* 记录列表 */}
            {loading && page === 1 ? (
                <div className="loading-container">加载中...</div>
            ) : records.length > 0 ? (
                <>
                    <List className="borrow-list">
                        {records.map(record => (
                            <List.Item
                                key={record.id}
                                onClick={() => viewDetail(record)}
                                arrow={<RightOutline />}
                                extra={renderStatusTag(record.approveType)}
                                description={
                                    <div className="item-description">
                                        <div>申请人: {record.applyUser}</div>
                                        <div>申请时间: {record.approveApplyTime}</div>
                                        <div>审批状态: {record.approveStatus || '待审批'}</div>
                                    </div>
                                }
                            >
                                <div className="item-title">
                                    <span className="asset-no">{record.assetNo}</span>
                                    <span className="device-type">{record.typeName}</span>
                                </div>
                                <div className="device-name">{record.name}</div>
                            </List.Item>
                        ))}
                    </List>

                    {/* 无限滚动加载组件 */}
                    <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
                </>
            ) : (
                <Empty
                    className="empty-container"
                    image={<CloseCircleOutline style={{ fontSize: 48 }} />}
                    description="暂无审批记录"
                />
            )}

            {/* 筛选弹窗 */}
            <Popup
                visible={filterVisible}
                onMaskClick={() => setFilterVisible(false)}
                position="right"
                bodyStyle={{ width: '80vw' }}
            >
                <div className="filter-container">
                    <NavBar
                        back="取消"
                        onBack={() => setFilterVisible(false)}
                    >
                        筛选条件
                    </NavBar>

                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={applyFilter}
                        footer={
                            <div className="filter-buttons">
                                <Button block onClick={resetFilter}>重置</Button>
                                <Button block type="submit" color="primary">应用</Button>
                            </div>
                        }
                    >
                        <Form.Header>审核类型</Form.Header>
                        <Form.Item name="approveType">
                            <div className="status-options">
                                <Space wrap>
                                    <Tag
                                        color={filterConfig.approveType === '' ? 'primary' : 'default'}
                                        onClick={() => setFilterConfig({ ...filterConfig, approveType: '' })}
                                    >
                                        全部
                                    </Tag>
                                    {allApproveTypes.map(approveType => (
                                        <Tag
                                            key={approveType}
                                            color={filterConfig.approveType === approveType ? 'primary' : 'default'}
                                            onClick={() => setFilterConfig({ ...filterConfig, approveType: approveType })}
                                        >
                                            {approveType}
                                        </Tag>
                                    ))
                                    }
                                </Space>

                            </div>
                        </Form.Item>

                        <Form.Header>申请时间</Form.Header>
                        <Form.Item name="applyStartTime" label="开始日期"
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current?.open()
                            }}>
                            <DatePicker
                                value={filter.applyStartTime}
                                onConfirm={(val) => {
                                    setFilterConfig({ ...filterConfig, applyStartTime: dayjs(val).format('YYYY/MM/DD') })
                                }}
                            >
                                {value =>
                                    value ? dayjs(value).format('YYYY/MM/DD') : '请选择日期'
                                }
                            </DatePicker>
                        </Form.Item>
                        <Form.Item name="applyEndTime" label="结束日期"
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current?.open()
                            }}>
                            <DatePicker
                                value={filter.applyEndTime}
                                onConfirm={(val) => setFilterConfig({ ...filterConfig, applyEndTime: dayjs(val).format('YYYY/MM/DD') })}
                            >
                                {(value) =>
                                    value ? dayjs(value).format('YYYY/MM/DD') : '请选择结束日期'
                                }
                            </DatePicker>
                        </Form.Item>
                    </Form>
                </div>
            </Popup>
        </div>
    );
};

export default ApproveHisPage;